<template>
  <div class="login">
    <div class="login__wrapper">
      <Logo />
      <q-form @submit="onSubmit" class="login__form">
        <CustomInput
          class="login__form_item q-mb-sm"
          :value="email"
          @change_input="(val) => email = val"
          label="Введите почту"
          :required="true"
          :hideBottomSpace="false"
          lazy-rules
          :rules="[(val) => (val && val.length > 0) || 'Введите email']"
        />
        <div class="flex justify-center items-center">
          <CustomButton
            class="login__submit"
            type="submit"
            color="primary-light"
            :disable="loading || btnDisabled"
            :loading="loading"
          >
            Сбросить пароль
          </CustomButton>
        </div>
        <router-link :to="pages.login" class="login__link">
          <p class="login__forget tw-text-primary-light">Войти</p>
        </router-link>
      </q-form>
    </div>
  </div>
</template>

<script>
import {PAGES} from "@/constants";
import CustomInput from "@/components/form/CustomInput";
import {useCustomSnackbar} from "@/_helpers/hooks/useCustomSnackbar";
import {onForgetPasswordSubmit} from "@/views/ForgetPassword/services";
import Logo from "../Login/Logo.vue";
import CustomButton from "@/components/common/CustomButton";

export default {
  name: "ForgetPassword",
  components: {CustomInput, Logo, CustomButton},
  setup() {
    const {showSucceedSnackbar} = useCustomSnackbar();
    return {showSucceedSnackbar};
  },
  methods: {
    async onSubmit() {
      const body = { login: this.email };
      this.loading = true;
      const res = await onForgetPasswordSubmit(body)
      this.loading = false;
      if (res) {
        this.showSucceedSnackbar("Новый пароль отправлен на почту");
        this.$router.push("/login");
      }
    },
  },
  computed: {
    pages() {
      return PAGES;
    },
  },
  data() {
    return {
      loading: false,
      email: "",
    };
  },
};
</script>

<style scoped lang="scss">
.login {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, .3);

  &__wrapper {
    width: 440px;
    background-color: #fff;
    padding: 60px 35px;
    height: auto;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 16px;
  }

  &__form {
    width: 100%;
    margin-top: 45px;

    &_item {
      margin-top: 0;
      margin-left: 0;
      width: 100%;
      border-radius: 4px !important;
    }
  }

  &__submit {
    width: 100%;
    height: 45px;
    margin-left: 0;
    margin-top: 5px;
  }

  &__forget {
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    margin-top: 20px;
    transition: all 0.3s;

    &:hover {
      text-decoration: underline;
    }
  }

  &__link {
    text-decoration: none;
  }
}
</style>
